import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/api/errors';

/**
 * TanStack Query defaults. We do NOT retry auth/permission/validation errors
 * (retrying a 401/403/400 is pointless); transient errors get up to 2 retries.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isApiError(error) && ['unauthenticated', 'forbidden', 'validation', 'not_found'].includes(error.kind)) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});
